import { useContext, VFC } from "react";
// Libraries
import { useMutation } from "@apollo/client";
// API
import { MARK_LOT_LIVESTOCK_AS_RECEIVED } from "trading/api/Liveweight/mutations";
import {
  LotBuyerReceivedAnimals,
  LotBuyerReceivedAnimalsVariables,
} from "trading/api/Liveweight/types/LotBuyerReceivedAnimals";
// Utils
import { eventsRequest } from "api/restAPI";
// Components
import { Button } from "components";
// Utils
import { CommonContext } from "config/commonProvider";
import { getBUFromLocalStorage } from "helpers/storage";

interface BuyerListingDeliveryProps {
  listingId: number;
  onNoFurtherAction: () => void;
}

export const BuyerListingDelivery: VFC<BuyerListingDeliveryProps> = ({ listingId, onNoFurtherAction }) => {
  const { showNotification } = useContext(CommonContext);

  const [markLotLivestockAsReceived] = useMutation<LotBuyerReceivedAnimals, LotBuyerReceivedAnimalsVariables>(
    MARK_LOT_LIVESTOCK_AS_RECEIVED,
  );

  const handleMarkAsReceived = async (): Promise<void> => {
    try {
      const { data } = await markLotLivestockAsReceived({
        variables: {
          input: {
            businessUnit: getBUFromLocalStorage(),
            id: listingId,
          },
        },
      });

      if (data?.lotBuyerReceivedAnimals?.errors) {
        showNotification({
          message: "We were unable to mark animals as received, please try again.",
          variant: "error",
        });
      } else {
        eventsRequest({ name: "listing-livestock-received", details: { lotId: listingId } });
        onNoFurtherAction();
      }
    } catch (error) {
      showNotification({
        variant: "error",
        message: "Error marking animals as received.",
      });
    }
  };

  return <Button caption="Mark as received" onClick={handleMarkAsReceived} />;
};
